module.exports = __webpack_public_path__ + "img/pick3.5370ec5f.png";